import DocumentSchema from '@components/DocumentSchema';
import type { Article } from 'schema-dts';
import type { Narrative } from '@/pages/Narrative/hooks/useNarrative';
import { useDescription } from '@/pages/Narrative/hooks';
import { getCommentSchema } from '@/utilities/comment/comment';
import { useMemo } from 'react';

type Props = {
  narrative: Narrative;
};

export const NarrativeSchema = ({ narrative }: Props) => {
  const {
    slug,
    title,
    owner,
    coverImageUrl,
    createdAt,
    updatedAt,
    contentBlocks,
    company,
  } = narrative;
  const { canonicalCommunityUrl } = company ?? {};
  const description = useDescription({ contentBlocks });
  const comments = useMemo(
    () => getCommentSchema(narrative.comments),
    [narrative.comments]
  );

  return (
    <DocumentSchema<Article>
      item={{
        '@context': 'https://schema.org',
        '@type': 'Article',
        '@id': `https://simplywall.st${canonicalCommunityUrl}/${slug}`,
        about: {
          '@type': 'CreativeWork',
          name: title,
          description: description,
        },
        headline: title,
        description: description,
        author: [
          {
            '@type': 'Person',
            name: owner?.displayName || '',
            jobTitle: owner?.role || '',
            url: owner?.publicId
              ? `https://simplywall.st/community/users/${owner.publicId}`
              : '',
          },
        ],
        image: [coverImageUrl],
        datePublished: createdAt,
        dateModified: updatedAt ?? undefined,
        publisher: [
          {
            '@type': 'Organization',
            name: 'Simply Wall St',
            legalName: 'Simply Wall St',
            url: 'https://simplywall.st',
            logo: {
              '@type': 'ImageObject',
              url: 'https://simplywall.st/news/images/sws-logo.svg',
            },
          },
        ],
        comment: comments.length > 0 ? comments : undefined,
      }}
    />
  );
};
